import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import CompCard from '@@/home/card.vue';
import { addImpression } from "@/utils/sensors-inject.js";
import { ref, watch } from 'vue';
import { useExposureObserver } from "@/utils/useExposureObserver";
export default {
  props: {
    item: Object,
    index: Number
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    const proItem = ref(null);
    // 2. 调用 useExposureObserver Composable
    // 将 targetElement ref 传递给 Composable，以及其他配置
    const {
      isIntersecting,
      isExposed,
      reobserve
    } = useExposureObserver(proItem,
    // 传入要观察的 DOM 元素的 ref
    {}, false // 传递 `once` 属性
    );
    // 3. 监听 `isExposed` 状态的变化，执行你“曝光到点”的业务逻辑
    watch(isExposed, newVal => {
      if (newVal) {
        addImpression({
          item_id: props.item.pro_id,
          category: props.item.category,
          sec_business_line: "101",
          page_source: "品类月",
          module: "feed流",
          module_position: props.index
        });
      }
    });

    // 如果父组件需要访问 `reobserve` 或其他内部状态，可以使用 `defineExpose` 暴露出去
    expose({
      reobserve,
      isExposed,
      isIntersecting
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "proItem",
        ref: proItem
      }, [_createVNode(CompCard, {
        item: props.item
      }, null, 8, ["item"])], 512);
    };
  }
};